module.exports = __webpack_public_path__ + "media/applicants/sign_papers-d1624fec.png";